module.exports = __webpack_public_path__ + "static/media/Shopify-App-Store-Badge-Final-White.3ebcd4a7.svg";